module.exports = __webpack_public_path__ + "media/hyper/images/products/product-3-80008a4bee8ee9575a4e2f11c6f7ca5d.jpg";